import { Modal } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import { AgreementApiModel } from '../../models/DealModel';
import styles from './wizard.module.scss';
// import DealSelector from './DealSelector';
import { User } from '../../models/UserModels';
import SelectAgreement from './SelectAgreement';
import WizardContainer from './WizardContainer';

export type WizardStep =
  | 'product'
  | 'group-products'
  | 'group-name'
  | 'user'
  | 'user-email'
  | 'user-email-confirmation'
  | 'user-domain'
  | 'user-domain-confirmation'
  | 'user-wildcard';

export enum EntryPoint {
  VIEW_USER_MODAL = 'view-user-modal',
}

export type WizardAction = 'add' | 'remove' | 'restore' | 'restoreBulk';

interface InviteWizardProps {
  deal?: AgreementApiModel;
  onCancel?: () => void;
  step?: WizardStep;
  singleAgreement?: boolean;
  entryPoint?: EntryPoint;
  people?: User[];
  action?: WizardAction;
}

export default function InviteWizard({
  deal = undefined,
  onCancel = () => {},
  step = undefined,
  singleAgreement = false,
  entryPoint = undefined,
  people = undefined,
  action = 'add',
}: InviteWizardProps) {
  const [activeDeal, setActiveDeal] = useState(deal);
  const [isDealsSelectionEnabled, setDealsSelectionEnabled] = useState(false);
  const [fromDealSelector, setFromDealSelector] = useState(false);

  // SELECT AGREEMENT STATES
  const [displayedDeals, setDisplayedDeals] = useState<AgreementApiModel[]>([]);
  const [activeTab, setActiveTab] = useState(0);

  const onDealSelect = (
    selectedDeal: AgreementApiModel,
    dealsSelectionEnabled: boolean,
  ) => {
    setDealsSelectionEnabled(dealsSelectionEnabled);
    setActiveDeal(selectedDeal);
    setFromDealSelector(true);
  };

  // Animation workaround. Remove, when DSM supported
  const [animationClassName, setAnimationClassName] = useState('hidden');
  useEffect(() => {
    setTimeout(() => setAnimationClassName(''), 0);
  }, []);

  return (
    <Modal
      show
      customClassName={`m-0 invite-wizard ${styles.wizardModal} ${animationClassName}`}
      variant="input"
      onClose={onCancel}
    >
      <div className={styles.wizardContent}>
        {activeDeal && (
          <WizardContainer
            deal={activeDeal}
            defaultProducts={[]}
            setActiveDeal={isDealsSelectionEnabled ? setActiveDeal : undefined}
            initialStep={step}
            fromDealSelector={fromDealSelector}
            hasSingleAgreement={singleAgreement}
            people={people}
            action={action}
            closeWizard={onCancel}
          />
        )}

        {!activeDeal && (
          <SelectAgreement
            onCancel={onCancel}
            selectDeal={onDealSelect}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            displayedDeals={displayedDeals}
            setDisplayedDeals={setDisplayedDeals}
            entryPoint={entryPoint}
            people={people}
            action={action}
          />
        )}
      </div>
    </Modal>
  );
}
